/**
 * @desc 产品BOM-审批
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.ProductBomApprovalRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productBom/approval`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
